/**
 * Copyright (c) 2019-Present Syncari - All rights reserved.
 */
import cx from 'classnames';
import * as React from 'react';

import type { SwitchProps } from '../../types';
import './Switch.less';

const Switch = React.forwardRef<HTMLInputElement, SwitchProps>(
  (
    {
      checked,
      defaultChecked = false,
      onChange,
      disabled = false,
      label,
      size = 'medium',
      id,
      name,
      'aria-label': ariaLabel,
      className,
    },
    ref
  ) => {
    const isControlled = checked !== undefined;
    const [internalChecked, setInternalChecked] = React.useState(defaultChecked);
    const currentChecked = isControlled ? !!checked : internalChecked;

    const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
      if (disabled) return;
      if (!isControlled) setInternalChecked(e.target.checked);
      onChange?.(e.target.checked);
    };

    return (
      <label className={cx('ds-switch', `ds-switch--${size}`, { 'ds-switch--disabled': disabled }, className)}>
        <input
          ref={ref}
          type="checkbox"
          role="switch"
          id={id}
          name={name}
          aria-label={ariaLabel}
          aria-checked={currentChecked}
          className="ds-switch__input"
          checked={currentChecked}
          disabled={disabled}
          onChange={handleChange}
        />
        <span className="ds-switch__track" aria-hidden="true">
          <span className="ds-switch__thumb" />
        </span>
        {label && <span className="ds-switch__label">{label}</span>}
      </label>
    );
  }
);

Switch.displayName = 'Switch';

export default Switch;
